const {
    SHOW_NOTIFICATION_DIALOG_EMERGENCY_0RDER,
    HIDE_NOTIFICATION_DIALOG_EMERGENCY_0RDER,
  } = require("./action-type");
  
  export const showNotificationDialogEmergencyOrder = (title, content,button) => {
    return {
      type: SHOW_NOTIFICATION_DIALOG_EMERGENCY_0RDER,
      payload: { title, content,button },
    };
  };
  
  export const hideNotificationDialogEmergencyOrder = () => {
    return {
      type: HIDE_NOTIFICATION_DIALOG_EMERGENCY_0RDER,
    };
  };
  